module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular.e18bbf611f2a2e43afc071aa2f4e1512.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-css-only/fonts/glyphicons-halflings-regular.ttf
 ** module id = 450
 ** module chunks = 1
 **/